import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import { ClickIt, DateAlertTitle } from '../../../Constants/Constants';
import { DateAlertSubTitle } from '../../../Data/BonusUi/SweetAlert';
import CommonCardHeader from '../../CommonComponents/CommonCardHeader/CommonCardHeader';

const DateAlert = () => {
  const handleAlert = async () => {
    const { value: date } = await Swal.fire({
      title: "Select departure date",
      input: "date",
      didOpen: () => {
        const today = new Date().toISOString();
        const inputElement = Swal.getInput();
        if (inputElement) {
          inputElement.min = today.split("T")[0];
        }
      }
    });

    if (date) {
      Swal.fire("Departure date", date);
    }
  };

  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={DateAlertTitle} span={DateAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="danger" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DateAlert;
